import { render, staticRenderFns } from "./TournamentAwardsCard.vue?vue&type=template&id=35f1f0d4&scoped=true"
import script from "./TournamentAwardsCard.vue?vue&type=script&lang=js"
export * from "./TournamentAwardsCard.vue?vue&type=script&lang=js"
import style0 from "./TournamentAwardsCard.vue?vue&type=style&index=0&id=35f1f0d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1f0d4",
  null
  
)

export default component.exports